import React, { Component } from 'react'

import * as utils from "../../utils";
import { openSlideshow } from "../../slideshow/actions";
import RouterLink from "../../common/components/router-link";
import RsvpToPerformActionButton from "../../common/components/rsvp-to-perform-action-button";

const FeedContent = function(props) {
  const hasComment = props.post.comment && props.post.comment.length > 0;
  return (
    <div className={`feed-content ${hasComment ? "has-comment" : ""}`}>
      {getPostContent(props.post)}
    </div>
  );
}

function getPostContent(post) {
  const { id, content, post_type } = post;
  let c = null;
  switch (post_type) {
    case 'single_photo':
      c = <SinglePhotoContent content={content} postId={id} />;
      break;
    case 'multi_photo':
      c = <MultiPhotoContent content={content} />;
      break;
    case 'rsvp':
      c = <RsvpStatusContent content={content} />;
      break;
    case 'what_to_bring_created':
      c = (
        <WhatToBringContent>
          Created a What to Bring list. Make sure to sign up to bring something!
        </WhatToBringContent>
      );
      break;
    case 'what_to_bring_selection':
      c = (
        <WhatToBringContent>
          Signed up to bring <b>{content.quantity} {content.item}</b>
        </WhatToBringContent>
      );
      break;
    case 'poll_created':
      c = (
        <PollsContent>
          Created the <b>'{content.question}'</b> poll. Make sure to cast your vote!
        </PollsContent>
      );
      break;
    case 'poll_voted':
      c = (
        <PollsContent>
          Voted for <b>'{content.option}'</b> in the <b>'{content.question}'</b> poll.
        </PollsContent>
      );
      break;
    case 'poll_vote_changed':
      c = (
        <PollsContent>
          Changed their vote to <b>'{content.option}'</b> in the <b>'{content.question}'</b> poll.
        </PollsContent>
      );
      break;
    case 'donations_added':
      c = (
        <DonationsContent>
          Added Charity Donations for <b>'{content.organization}'</b>. Make sure to donate.
        </DonationsContent>
      );
      break;
    case 'donations_goal_set':
      c = (
        <DonationsContent>
          Set a donation goal of ${utils.formatMoney(content.goal)} for <b>'{content.organization}'</b>.
        </DonationsContent>
      );
      break;
    case 'donations_goal_met':
      c = (
        <DonationsContent>
          ${utils.formatMoney(content.goal)} goal met for <b>'{content.organization}'</b>.
        </DonationsContent>
      );
      break;
    case 'donations_donated':
      c = (
        <DonationsContent>
          Donated to <b>'{content.organization}'</b>.
        </DonationsContent>
      );
      break;
    case 'wedding_registry_added':
      c = (
        <GiftsContent iconClassName="icon-registry_theknot">
          Added a Registry to this event.
        </GiftsContent>
      );
      break;
    case 'baby_registry_added':
      c = (
        <GiftsContent iconClassName="icon-registry_thebump">
          Added a Registry to this event.
        </GiftsContent>
      );
      break;
    case 'wishlist_added':
      c = (
        <GiftsContent iconClassName="icon-wishlist">
          Added an Amazon Wishlist to this event.
        </GiftsContent>
      );
      break;
    case 'sponsored_registry_added':
    case 'sponsored_registry_selection':
      c = (
          <SponsoredRegistryContent post_data={content} />
        );
        break;
  }
  return c;
}

const SinglePhotoContent = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  render: function() {
    const url = this.props.content.url;
    return (
      <a href="#" onClick={this.handleClick}>
        <img src={`${url}=s600`} />
      </a>
    )
  },
  handleClick: function(e) {
    const postId = this.props.postId;
    e.preventDefault();
    openSlideshow(postId);
  }
})

const MultiPhotoContent = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  render: function() {
    const photos = this.props.content.objects;
    const totalPhotos = photos.length;
    const maxRender = 4;
    const toRender = totalPhotos > maxRender ? maxRender : totalPhotos;
    let photoNodes = [];
    for (let i = 0; i < toRender; i++) {
      const photo = photos[i];
      photoNodes.push(
        <a href="#" onClick={this.handleClick.bind(this, photo.id)} key={photo.id}>
          <div className="multi-photo-panel" style={{backgroundImage: `url(${photo.url}=s600)`}} />
          { i == maxRender - 1 && totalPhotos > maxRender &&
            <div className="more-photos-link">+{totalPhotos - maxRender}</div>
          }
        </a>
      )
    }
    return (
      <div className={`multi-photo-wrap multi-photo-wrap-${toRender}`}>
        {photoNodes}
      </div>
    )
  },
  handleClick: function(postId, e) {
    e.preventDefault();
    openSlideshow(postId);
  }
})

function RsvpStatusContent(props) {
  const { response, kids_allowed, number_of_adults, number_of_kids, rsvp_changed } = props.content;
  const negativeResponse = response === "no";
  const guestNoun = number_of_adults === 1 ? "guest" : "guests";
  const adultNoun = number_of_adults === 1 ? "adult" : "adults";
  const kidNoun = number_of_kids === 1 ? "kid" : "kids";
  const adultOrGuest = kids_allowed ? adultNoun : guestNoun;
  const adultStr = number_of_adults > 0 ? `${number_of_adults} ${adultOrGuest}` : "";
  const kidStr = number_of_kids > 0 ? `${number_of_kids} ${kidNoun}` : "";
  const andWord = number_of_adults > 0 && number_of_kids > 0 ? "and" : "";
  const intro = rsvp_changed ? "Changed reply to" : "Replied";
  const wrapClassName = `rsvp-${response}`;
  return (
    <div className={wrapClassName}>
      <h4>{intro} {response}</h4>
      { !negativeResponse &&
        <span>For {adultStr} {andWord} {kidStr}</span>
      }
    </div>
  )
}

const WhatToBringContent = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  render: function() {
    const wtbUrl = utils.eventTabUrlPath("what-to-bring");
    const hasRsvpd = utils.hasRsvpd();
    return (
      <div className="feed-post-wtb">
        <RouterLink to={wtbUrl} trackingSrc="wtb-feed-post-icon">
          <i className="icon-wtb" />
        </RouterLink>
        {this.props.children}
        <div className="feed-post-btn">
          { hasRsvpd &&
            <RouterLink
              to={wtbUrl}
              className="button-primary-inverse small"
              trackingSrc="wtb-feed-post-button"
            >
              Contribute
            </RouterLink>
          }
          { !hasRsvpd &&
            <RsvpToPerformActionButton action="contribute" />
          }
        </div>
      </div>
    )
  }
});

const PollsContent = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  render: function() {
    const pollsUrl = utils.eventTabUrlPath("polls");
    const hasRsvpd = utils.hasRsvpd();
    return (
      <div className="feed-post-poll">
        <RouterLink to={pollsUrl} trackingSrc="polls-feed-post-icon">
          <i className="icon-polls" />
        </RouterLink>
        {this.props.children}
        <div className="feed-post-btn">
          { hasRsvpd &&
            <RouterLink
              to={pollsUrl}
              className="button-primary-inverse small"
              trackingSrc="polls-feed-post-button"
            >
              Vote Now
            </RouterLink>
          }
          { !hasRsvpd &&
            <RsvpToPerformActionButton action="vote" />
          }
        </div>
      </div>
    )
  }
});

const DonationsContent = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  render: function() {
    const donationsUrl = utils.eventTabUrlPath("donate");
    return (
      <div className="feed-post-donations">
        <RouterLink to={donationsUrl}>
          <i className="icon-donations" />
        </RouterLink>
        {this.props.children}
        <div className="feed-post-btn">
          <RouterLink to={donationsUrl} className="button-primary-inverse small">
            Donate Now
          </RouterLink>
        </div>
      </div>
    )
  }
});

const GiftsContent = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  render: function() {
    const giftsUrl = utils.eventTabUrlPath("gifts");
    return (
      <div className="feed-post-gifts">
        <RouterLink to={giftsUrl}>
          <i className={this.props.iconClassName} />
        </RouterLink>
        {this.props.children}
        <div className="feed-post-btn">
          <RouterLink to={giftsUrl} className="button-primary-inverse small">
            Send the Gift
          </RouterLink>
        </div>
      </div>
    )
  }
});

const SponsoredRegistryContent = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  render: function() {
    const giftsUrl = utils.eventTabUrlPath("gifts");
    const hasRsvpd = utils.hasRsvpd();
    const iconUrl = this.props.post_data.icon_url;
    const message = this.props.post_data.message;
    const topDivClasses = `feed-post-sponsored_registry ${this.props.post_data.sponsor}`;
    return (
      <div className={topDivClasses}>
        <img className="sponsored_registry_icon" src={iconUrl} />
        <p className="sponsored_registry_message">{message}</p>
        { window.has_sponsored_registry &&
          <div className="feed-post-btn">
          { hasRsvpd &&
            <RouterLink
              to={giftsUrl}
              className="button-primary-inverse small"
              trackingSrc="sponsored-registry-feed-post-button"
            >
              Contribute
            </RouterLink>
          }
          { !hasRsvpd &&
            <RsvpToPerformActionButton action="contribute" />
          }
          </div>
        }
      </div>
    )
  }
});

export default FeedContent;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/feed-content.es6